<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    let mode = this.$route.hash ? this.$route.hash : 'production'
    this.$store.dispatch('PanoramasStore/fetch', mode)
  }
}
</script>
<style lang="scss">
@import '@/styles/app.scss';
</style>
